import {
  base_colorContentBorder,
  grey100,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const subtitle = css`
  ${font_md};
  color: ${text_colorTextSecondary};
`

export const actions = css`
  display: flex;
  flex-direction: row;
  gap: ${spacing(2)};
`

export const tableCard = css`
  display: flex;
  flex-direction: column;
`

export const toolbar = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-bottom: 1px solid ${base_colorContentBorder};
`

export const table = css`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    text-align: left;
  }

  th {
    font-family: ${font_family_weight_regular};
    ${font_sm};
    color: ${text_colorTextSecondary};
    background-color: ${grey100};
    padding: ${spacing(3)} ${spacing(4)};
    border-bottom: 1px solid ${base_colorContentBorder};
  }

  td {
    font-family: ${font_family_weight_regular};
    ${font_md};
    color: ${text_colorTextPrimary};
    padding: ${spacing(4)} ${spacing(4)};
  }
`

export const cardProgramCell = css`
  font-family: ${font_family_weight_medium};
`

export const networkCell = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const networkLogo = css`
  width: 32px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
`

export const helpGuideIcon = css`
  width: 16px;
  height: 16px;
`

export const actionCell = css`
  text-align: right;
`

export const seeEnrolledChevron = css`
  width: 16px;
  height: 16px;
  margin-left: ${spacing(1)};
`

export const messageCell = css`
  padding: ${spacing(8)} ${spacing(4)};
  text-align: center;
  color: ${text_colorTextSecondary};
  ${font_md};
`

export const loadingRow = css`
  td {
    height: ${spacing(5)};
  }
`

export const loadingBar = css`
  display: block;
  height: 14px;
  background-color: ${grey100};
  border-radius: 4px;
`

export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
